import { MortgageAction } from "./Actions";
import { MortgageState } from "./Reducer";

export function handleSetMortgageAction(state: MortgageState, action: MortgageAction<any>) {
    const { mortgage } = action.payload;
    return {
        ...state,
        mortgage: mortgage,
    };
}

export function handleSetNewMortgageAction(state: MortgageState, action: MortgageAction<any>) {
    const { newMortgage } = action.payload;
    return {
        ...state,
        newMortgage: newMortgage,
    };
}
